import _extends from "@babel/runtime/helpers/extends";
import { jsx } from '@emotion/core';
import { baseValidationFn } from './utils';
import { PROPS_TO_FILTER } from './constants';
import { Container, StyledInput, StyledLabel } from './styledComponents';
import { createChangeHandler, filterProps } from '../../../../utils';

var BaseCheckboxAndRadioButton = props => {
  var {
    blurHandler,
    containerStyleOverrides,
    focusHandler,
    id,
    inputStyleOverrides,
    label,
    labelStyleOverrides,
    type
  } = props;
  var filteredProps = filterProps(props, PROPS_TO_FILTER);
  var changeHandler = createChangeHandler({
    generateMeta: props.generateChangeHandlerMeta,
    hasMaxLen: false,
    props,
    validationFn: props.validationFn || baseValidationFn
  });
  return jsx(Container, {
    css: containerStyleOverrides
  }, jsx(StyledInput, _extends({}, filteredProps, {
    css: inputStyleOverrides,
    onBlur: blurHandler,
    onChange: changeHandler,
    onFocus: focusHandler,
    type: type
  })), jsx(StyledLabel, {
    css: labelStyleOverrides,
    hasError: props.displayError,
    htmlFor: id
  }, label));
};

export { BaseCheckboxAndRadioButton };